import React from 'react';
import {FilterPanelFormContent} from './FilterPanelFormContent';
import {CollapsibleSidebar} from './CollapsibleSidebar';
import {FilterOnFieldSetup} from './FilterOnFieldSetup';
import {FilterFormSetup} from './FilterFormSetup';

export const AdvancedFilters = ({
    filters,
    applyFilter,
    validFilterFormatters,
    filterRef,
    showFilterPanel,
    toggleFilterPanel,
    entityType,
    size,
    t,
}) => {
    return (
        <FilterFormSetup
            size={size}
            filters={filters}
            applyFilter={applyFilter}
            render={(arrayHelpers) => (
                <>
                    <FilterOnFieldSetup
                        filterFormatters={validFilterFormatters}
                        arrayHelpers={arrayHelpers}
                        ref={filterRef}
                    />
                    <CollapsibleSidebar
                        show={showFilterPanel}
                        onHide={toggleFilterPanel}
                        title={t('filterPanel.advancedFilters')}>
                        <FilterPanelFormContent
                            entityType={entityType}
                            filters={filters}
                            validFilterFormatters={validFilterFormatters}
                            t={t}
                            arrayHelpers={arrayHelpers}
                        />
                    </CollapsibleSidebar>
                </>
            )}
        />
    );
};
